export enum OrderApprovalType {
  MANUAL = 'manual',
  AUTO = 'auto',
}

export enum OrderAutoApproveTypes {
  instantly = 'instantly',
  delayed = 'delayed',
}
